import {
  addSelectedCMS,
  setAiTrackerAPIKey,
  setAiTrackerIntegrationAge,
  setIsTrackable,
} from '../../../store/reducers/userSlice';
import store from '../../../store/store';
import get_checkout_tracking_api_call from '../integration/get_checkout_tracking_api_call';
import post_integration_api_call from '../integration/post_integration_api_call';

interface ApiDataType {
  api_key: string;
  [key: string]: any;
}

//get basic dashboard statistics
export default async function get_available_tracking_data_api_call(
  checkScriptConnection: boolean = false
) {
  try {
    const getRes: ApiDataType = await get_checkout_tracking_api_call(
      checkScriptConnection
    );

    if (!getRes || Object.keys(getRes).length === 0) {
      const sendingData = {
        name: 'checkout-tracking-class-names',
        type: 'tracker',
        configuration: { key: 'value' },
      };
      const postRes = await post_integration_api_call(
        sendingData,
        undefined,
        {
          is_autofill_enabled: 'false',
        },
        {
          is_tracker_active: 'true',
        },
        {
          optimization_adjustment_ratio: 0,
        }
      );
      if (postRes && postRes.api_key) {
        store.dispatch(setAiTrackerAPIKey(postRes?.api_key));
      }
      store.dispatch(setIsTrackable(false));
    } else {
      if (
        getRes?.configuration &&
        JSON.stringify(getRes.configuration) ===
          JSON.stringify({ key: 'value' })
      ) {
        store.dispatch(setIsTrackable(false));
      } else {
        store.dispatch(setIsTrackable(true));
      }

      store.dispatch(setAiTrackerAPIKey(getRes?.api_key || ''));
      store.dispatch(
        setAiTrackerIntegrationAge(getRes?.integration_stats?.age || '')
      );
      store.dispatch(
        addSelectedCMS(getRes?.additional_configs?.CMS_type || '')
      );
    }
  } catch (error) {
    console.error('Error fetching tracking data:', error);
  }
}
